__turbopack_context__.v({
  "brandRow": "signin-module__ZbF9kW__brandRow",
  "card": "signin-module__ZbF9kW__card",
  "codeInput": "signin-module__ZbF9kW__codeInput",
  "codeInputError": "signin-module__ZbF9kW__codeInputError",
  "contactFallback": "signin-module__ZbF9kW__contactFallback",
  "container": "signin-module__ZbF9kW__container",
  "divider": "signin-module__ZbF9kW__divider",
  "dividerText": "signin-module__ZbF9kW__dividerText",
  "emailButton": "signin-module__ZbF9kW__emailButton",
  "emailError": "signin-module__ZbF9kW__emailError",
  "emailForm": "signin-module__ZbF9kW__emailForm",
  "emailInput": "signin-module__ZbF9kW__emailInput",
  "errorBanner": "signin-module__ZbF9kW__errorBanner",
  "footer": "signin-module__ZbF9kW__footer",
  "footerLink": "signin-module__ZbF9kW__footerLink",
  "header": "signin-module__ZbF9kW__header",
  "inputWrapper": "signin-module__ZbF9kW__inputWrapper",
  "languageRow": "signin-module__ZbF9kW__languageRow",
  "logoMark": "signin-module__ZbF9kW__logoMark",
  "logoText": "signin-module__ZbF9kW__logoText",
  "primaryButton": "signin-module__ZbF9kW__primaryButton",
  "providerButton": "signin-module__ZbF9kW__providerButton",
  "providersContainer": "signin-module__ZbF9kW__providersContainer",
  "reminderText": "signin-module__ZbF9kW__reminderText",
  "spin": "signin-module__ZbF9kW__spin",
  "spinner": "signin-module__ZbF9kW__spinner",
  "successIcon": "signin-module__ZbF9kW__successIcon",
  "successMessage": "signin-module__ZbF9kW__successMessage",
  "successTitle": "signin-module__ZbF9kW__successTitle",
});
